import { IconWarningOutline } from '@/components/icons'
import { Button } from '@/components/shadcn/button'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary'

export function QueryErrorBoundary({
  children,
  errorMessage,
}: {
  children: React.ReactNode
  errorMessage: React.ReactNode
}) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={({ resetErrorBoundary }) => (
            <div className="mt-16 flex size-full justify-center">
              <div className="flex max-h-fit flex-col items-center gap-y-6 rounded-lg border border-destructive bg-destructive/10 p-4">
                <div className="flex items-center gap-4 rounded-md">
                  <IconWarningOutline className="size-8 text-destructive" />
                  {/* <span>
                    Failed to fetch data for <span className="font-semibold italic">"{contentId}"</span>
                  </span> */}
                  {errorMessage}
                </div>
                <Button variant="secondary" size="sm" onClick={() => resetErrorBoundary()}>
                  Try again
                </Button>
              </div>
            </div>
          )}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
